import { SbBlokData, storyblokEditable } from "@storyblok/react"
import { useRouter } from "next/router"
import PrimaryButton from "../../components/buttons/PrimaryButton"
import LazyYoutube from "@/components/testimonials/LazyYoutube"

export interface IYoutubeEmbed extends SbBlokData {
  videoId: string
  bgColor?: "white" | "orange1"
  maintainAspectRatio?: boolean
}

export default function YoutubeEmbedATF({
  blok,
  posterPreloadMedia,
}: {
  blok: IYoutubeEmbed
  // Viewports on which this copy is above the fold; see LazyYoutube.
  posterPreloadMedia?: string
}) {
  const { videoId, bgColor = "white", maintainAspectRatio = false } = blok

  return (
    <section
      className={`relative w-full flex flex-col items-center space-y-4 bg-${bgColor}`}
      {...storyblokEditable(blok)}
    >
      <LazyYoutube
        videoId={videoId}
        maintainAspectRatio={maintainAspectRatio}
        preloadMedia={posterPreloadMedia}
      />
    </section>
  )
}
